export default "__VITE_PUBLIC_ASSET__af98d881__"